export class Onlineuser {
  public id: string;
  public displayName: string;
  // 48x48 pixel avatar-image as base64-string
  public avatarImage: string;
  public location: string;

  constructor(id: string, displayName: string, location: string, avatarImage: string) {
    this.id = id;
    this.displayName = displayName;
    this.location = location;
    this.avatarImage = avatarImage;
  }
}
